import './bootstrap.js'
import swal from 'sweetalert'

// Login Form
document.getElementById('login-form').addEventListener('submit', e => {
  e.preventDefault()

  const form = e.target

  form.querySelectorAll('input, button').forEach(el => {
    el.disabled = true
  })
  form.querySelector('.btn').classList.add('btn--loading')

  axios.post(form.getAttribute('action'), {
    email: form.querySelector('input[name="email"]').value,
    password: form.querySelector('input[name="password"]').value,
    remember: (form.querySelector('input[name="remember"]').checked ? 1 : 0),
  })
  .then(response => {
    window.location = '/industry'
  })
  .catch(error => {
    form.querySelectorAll('input, button').forEach(el => {
      el.disabled = false
    })
    form.querySelector('.btn').classList.remove('btn--loading')

    let div = document.createElement('div');
    div.innerHTML = '<div class="alert alert-danger text-start">These credentials do not match our records.</div>'
    swal({
      content: div
    })
  })
})
